export const Costumes = [
    ['Explosive Diarrhea', '0'],
    ['Puberty', '1'],
    ['I Found Pills', '2'],
    ['Lord Of The Flies', '3'],
    ['Statue', '4'],
    ['Guppy', '5'],
    ['Wizard', '6'],
    ['Magdalene', '7'],
    ['Cain', '8'],
    ['Judas', '9'],
    ['Eve', '10'],
    ['Azazel', '11'],
    ['Eden', '12'],
    ['Samson', '13'],
    ['Blindfold', '14'],
    ['Blankface', '15'],
    ['Christmas', '16'],
    ['Purity Glow', '17'],
    ['Empty Vessel', '18'],
    ['Maw Mark', '19'],
    ['Mushroom', '20'],
    ['Angel', '21'],
    ['Bob', '22'],
    ['Drugs', '23'],
    ['Mom', '24'],
    ['Baby', '25'],
    ['Evil Angel', '26'],
    ['Poop', '27'],
    ['Relax', '28'],
    ['Overdose', '29'],
    ['Boomerang', '30'],
    ['Megablast', '31'],
    ['Lazarus', '32'],
    ['Lazarus2', '33'],
    ['Lilith', '34'],
    ['Iwata', '35'],
    ['Apollyon', '36'],
    ['Bookworm', '37'],
    ['Adulthood', '38'],
    ['Spiderbaby', '39'],
    ['Batwing Wings', '40'],
    ['Huge Growth', '41'],
    ['Era Walk', '42'],
    ['Sacrificial Altar', '43'],
    ['Forgotten', '44'],
    ['Brimstone2', '45'],
    ['Holy Card', '46'],
    ['Keeper', '47'],
    ['Spin To Win', '50'],
    ['Bethany', '51'],
    ['Jacob', '52'],
    ['Esau', '53'],
    ['Blood Oath', '54'],
    ['Intruder', '55'],
    ['Sol', '56'],
    ['It Hurts', '57'],
    ['Mars', '58'],
    ['Tooth And Nail', '59'],
    ['Reverse Magician', '60'],
    ['Reverse High Priestess', '61'],
    ['Reverse Empress', '62'],
    ['Reverse Chariot', '63'],
    ['Reverse Strength', '64'],
    ['Reverse Hanged Man', '65'],
    ['Reverse Sun', '66'],
    ['Reverse Devil', '67'],
    ['Reverse Chariot Alt', '68'],
    ['Reverse Temperance', '69'],
    ['Reverse Stars', '70'],
    ['Wavy Cap 1', '71'],
    ['Wavy Cap 2', '72'],
    ['Wavy Cap 3', '73'],
    ['Luna', '74'],
    ['Jupiter Body', '75'],
    ['Jupiter Body Angel', '76'],
    ['Jupiter Body Pony', '77'],
    ['Jupiter Body Whitepony', '78'],
    ['Isaac B', '79'],
    ['Magdalene B', '80'],
    ['Cain B', '81'],
    ['Judas B', '82'],
    ['Bluebaby B', '83'],
    ['Eve B', '84'],
    ['Samson B', '85'],
    ['Azazel B', '86'],
    ['Lazarus B', '87'],
    ['Eden B', '88'],
    ['Lost B', '89'],
    ['Lilith B', '90'],
    ['Keeper B', '91'],
    ['Apollyon B', '92'],
    ['Forgotten B', '93'],
    ['Bethany B', '94'],
    ['Jacob B', '95'],
    ['Azazels Rage 1', '96'],
    ['Azazels Rage 2', '97'],
    ['Azazels Rage 3', '98'],
    ['Azazels Rage 4', '99'],
    ['Esau Jr', '100'],
    ['Spirit Shackles Soul', '101'],
    ['Spirit Shackles Disabled', '102'],
    ['Berserk Samson', '103'],
    ['Lazarus2 B', '104'],
    ['Soul B', '105'],
    ['Forgotten Bomb', '106'],
    ['Extra Big Fan', '107'],
    ['Jacob2 B', '108'],
    ['Jacobs Curse', '109'],
    ['Bloody Babylon', '110'],
    ['Dark Arts', '111'],
    ['Lost Curse', '112'],
    ['Lazarus Soul Revive', '113'],
    ['Soul Magdalene', '114'],
    ['Soul Bluebaby', '115'],
    ['Mirror Death', '116'],
    ['Hemoptysis', '117'],
    ['I Found Horse Pills', '118'],
    ['Horse Puberty', '119'],
    ['Soul Forgotten', '120'],
    ['Soul Jacob', '121'],
  ]
  